import React, { useEffect, useState } from "react";
import { useStore } from "effector-react";
import { Preloader } from "../../../common/ui/Preloader/preloader";
import { ConfirmCode } from "../../../common/ui/ConfirmCode/ConfirmCode";
import { Counter } from "../../../common/ui/Counter/Counter";
import { validatePhoneRU } from "../../../common/functions";
import { pathAddAccountOnLogin } from "../../../common/config/vars";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../style/Login.css";
import { $SiteColors } from "../../../common/config/company-atts";
import {
  $currentAppCustomUserAgent,
  getCustomUserAgent,
  getCustomUserAgentASB,
  getCustomUserAgentKrk,
} from "../../../common/customUserAgent";
import { authenticateUser, checkAuthCode } from "../logics/apiAuthV2";
import { useHistory } from "react-router";
import {
  $accounts,
  AddChargesToAccount,
  AddOwnerTypeToAccount,
  queryAccounts,
  updateAccount,
} from "../../../common/accounts2";

toast.configure();

export const Login = () => {
  // Состояния для управления формой входа
  const [openSendSmsForm, setOpenSendSmsForm] = useState(
    "Введите код подтверждения, отправленный Вам на телефон"
  );
  const [isValid, setIsValid] = useState(false); // Флаг для проверки валидности номера телефона
  const [showLoader, setShowLoader] = useState(false); // Флаг для показа индикатора загрузки
  const [showLoaderCode, setShowLoaderCode] = useState(false); // Флаг для показа индикатора загрузки при проверке кода
  const [disableInputs, setDisabledInputs] = useState(false); // Флаг для блокировки ввода
  const [phoneStatus, setPhoneStatus] = useState(""); // Статус номера телефона (ошибки и т.д.)
  const [codeStatus, setCodeStatus] = useState(""); // Статус кода (ошибки и т.д.)
  const [phoneValue, setPhoneValue] = useState(""); // Значение номера телефона
  const [showConfirm, setShowConfirm] = useState(false); // Флаг для показа формы подтверждения кода
  const [confirmValue, setConfirmValue] = useState(""); // Значение кода подтверждения
  const [buttonText, setButtonText] = useState("Отправить код на телефон"); // Текст кнопки
  const [showCounter, setShowCounter] = useState(false); // Флаг для показа таймера
  const [time, setTime] = useState(60); // Время для таймера
  const [userSmsId, setUserSmsId] = useState(""); // Идентификатор SMS для подтверждения

  // Функция для обновления состояния показа формы подтверждения
  const updateShowConfirm = (newConfirm: boolean) => {
    setShowConfirm(newConfirm);
  };

  // Функция для обновления идентификатора SMS
  const updateUserSmsId = (newUserSmsId: string) => {
    setUserSmsId(newUserSmsId);
  };

  // Функция для обновления текста, показывающего, куда отправлен код
  const updateOpenSendSmsForm = (newUserSmsId: string) => {
    setOpenSendSmsForm(newUserSmsId);
  };

  // Функция для управления состоянием загрузки API
  const setShowLoaderApi = (flag: boolean) => {
    setShowLoader(flag);
    setShowCounter(flag);
    setDisabledInputs(flag);
    setIsValid(!flag);
  };

  // Функция для обновления статуса номера телефона
  const updatePhoneStatus = (newPhoneStatus: string) => {
    setPhoneStatus(newPhoneStatus);
  };

  // Функция для обновления статуса кода
  const updateCodeStatus = (newCodeStatus: string) => {
    setCodeStatus(newCodeStatus);
  };

  // Функция для управления состоянием загрузки кода
  const setShowLoaderCodeApi = (flag: boolean) => {
    setShowLoaderCode(flag);
  };

  const userAgent = useStore($currentAppCustomUserAgent); // Получаем User-Agent приложения
  const accounts = useStore($accounts); // Получаем список аккаунтов
  const history = useHistory(); // Используем хук для навигации

  // Эффект для проверки валидности номера телефона
  useEffect(() => {
    if (phoneValue && phoneValue.length === 16) setIsValid(true);
    else {
      setIsValid(false);
      setPhoneStatus("");
    }
  }, [phoneValue]);

  // Эффект для управления таймером
  useEffect(() => {
    if (time <= 0) {
      setShowLoader(false); // Скрываем индикатор загрузки
      setShowCounter(false); // Скрываем таймер
      setTime(60); // Сбрасываем таймер
      setButtonText("Отправить код повторно"); // Обновляем текст кнопки
      setDisabledInputs(false); // Разблокируем ввод
      setIsValid(true); // Устанавливаем валидность
    }
  }, [time]);

  const [confirmLoading, setConfirmLoading] = useState(false); // Флаг для загрузки подтверждения
  const [checkAuthSuccess, setCheckAuthSuccess] = useState(false); // Флаг успешной проверки кода

  // Эффект для обработки успешной проверки кода
  useEffect(() => {
    if (!confirmLoading && checkAuthSuccess) {
      if (accounts.accounts.length > 0) {
        // Если аккаунты уже существуют, переходим на главную страницу
        window.location.href = "/" + window.location.pathname.split("/")[1] + "/";
      } else {
        // Запрашиваем аккаунты, если их нет
        queryAccounts()
          .then(async (res) => {
            var bar = new Promise((resolve, reject) => {
              // Обрабатываем каждый аккаунт
              res.accounts.forEach(async (elem, index) => {
                await updateAccount({ account: elem, accounts: res.accounts });
                await AddChargesToAccount({
                  account: elem,
                  accounts: res.accounts,
                });
                // Добавляем тип владельца в зависимости от User-Agent
                if (
                  getCustomUserAgent() === getCustomUserAgentKrk() ||
                  getCustomUserAgent() === getCustomUserAgentASB()
                ) {
                  await AddOwnerTypeToAccount({
                    account: elem,
                    accounts: res.accounts,
                  });
                }
                // Если это последний элемент, разрешаем промис
                if (index === res.accounts.length - 1) resolve("@");
              });
            });

            if (res) {
              if (res.fail) throw new Error(res.failMsg); // Обработка ошибок
              else if (res.accounts.length > 0) {
                // Если аккаунты успешно получены, переходим на главную страницу
                window.location.href = "/" + window.location.pathname.split("/")[1] + "/";
              } else {
                // Если аккаунтов нет, переходим к добавлению аккаунта
                history.push(pathAddAccountOnLogin);
              }
            } else throw new Error("Что-то пошло не так(");
          })
          .catch((err) => toast.error(err.message)); // Показываем ошибку
      }
    }
  }, [confirmLoading, checkAuthSuccess]);

  // Обработчик изменения ввода номера телефона
  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const target = event.target;
    const value = target.value;
    const digitValue = value.replace(/\D/g, ""); // Оставляем только цифры
    setPhoneValue(validatePhoneRU(digitValue).phone); // Валидация и установка номера телефона
  }

  // Отправка кода: то же действие, что и по кнопке "Войти в ЛК" (кнопка и Enter в поле кода).
  const submitCode = () => {
    if (!showLoaderCode && confirmValue.length === 4) {
      checkAuthCode({
        code: confirmValue,
        userSmsId,
        updateCodeStatus,
        setShowLoaderCodeApi,
        setConfirmLoading,
        setCheckAuthSuccess,
      });
    }
  };

  // Enter отправляет код, пока открыта форма кода. Слушатель на документе, т.к.
  // после ввода 4-й цифры библиотека снимает фокус с поля — обработчик внутри поля не сработал бы.
  useEffect(() => {
    if (!showConfirm) return;
    const onKeyDown = (e: KeyboardEvent) => { if (e.key === "Enter") submitCode(); };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [showConfirm, confirmValue, showLoaderCode, userSmsId]);

  return (
    <div
      className="login"
      style={{ backgroundColor: $SiteColors.getState().cardBackgroundColor }} // Устанавливаем цвет фона
    >
      <div
        className="login__container"
        style={{ backgroundColor: $SiteColors.getState().cardColor }} // Устанавливаем цвет контейнера
      >
        <h3 className="login__title">Вход в личный кабинет</h3>
        <>
          <div className="login__form">
            <input
              type="tel"
              className="login__input"
              placeholder="Введите номер телефона"
              name="phone"
              required
              onChange={handleChange} // Обработчик изменения ввода
              disabled={disableInputs} // Блокировка ввода при загрузке
              value={phoneValue} // Значение номера телефона
              id="phone"
              pattern="\+7\(\d{3}\)\d{3}-\d{2}-\d{2}" // Шаблон для валидации ввода
              maxLength={16} // Максимальная длина ввода
              autoComplete="off" // Отключение автозаполнения
              onKeyDown={(event) => {
                // Обработка нажатия клавиши Enter
                if (
                  event.key === "Enter" &&
                  !disableInputs &&
                  phoneValue.length === 16
                ) {
                  authenticateUser({
                    phone: phoneValue,
                    userAgent,
                    updateUserSmsId,
                    updateShowConfirm,
                    updateOpenSendSmsForm,
                    updatePhoneStatus,
                    setShowLoaderApi,
                  });
                  setShowLoaderApi(true); // Показываем индикатор загрузки
                }
              }}
              onBlur={() => {
                // Обработка потери фокуса
                if (!disableInputs && phoneValue.length === 16) {
                  authenticateUser({
                    phone: phoneValue,
                    userAgent,
                    updateUserSmsId,
                    updateShowConfirm,
                    updateOpenSendSmsForm,
                    updatePhoneStatus,
                    setShowLoaderApi,
                  });
                  setShowLoaderApi(true); // Показываем индикатор загрузки
                  setConfirmLoading(true); // Устанавливаем флаг загрузки подтверждения
                }
              }}
            ></input>
            {!showLoader && !showCounter && (
              <label htmlFor="phone" className="login__label">
                Например, +7(999)000-00-00
              </label>
            )}
            {phoneStatus.length > 0 && phoneValue.length === 16 && (
              <p className="login__status login__status_error">{phoneStatus}</p> // Показываем статус номера телефона
            )}
            <button
              onClick={() => {
                // Обработка нажатия кнопки отправки кода
                if (isValid) {
                  authenticateUser({
                    phone: phoneValue,
                    userAgent,
                    updateUserSmsId,
                    updateShowConfirm,
                    updateOpenSendSmsForm,
                    updatePhoneStatus,
                    setShowLoaderApi,
                  });
                  setShowLoaderApi(true); // Показываем индикатор загрузки
                }
              }}
              type="submit"
              className="login__button"
              disabled={!isValid} // Блокировка кнопки при невалидном номере
              style={{ backgroundColor: $SiteColors.getState().backBtnSubmit }} // Устанавливаем цвет кнопки
            >
              {showLoader && <Preloader small />} 
              {showCounter && <Counter time={time} setTime={setTime} />} 
              {!showLoader && !showCounter && buttonText} 
            </button>
          </div>
          <div
            className={
              showConfirm
                ? "form__confirm-container form__confirm-container_open"
                : "form__confirm-container"
            }
          >
            <p className="login__confirm-text">{openSendSmsForm}</p> 
            <ConfirmCode setConfirmValue={setConfirmValue} length={4} focusOn={showConfirm} />
            {codeStatus.length > 0 && (
              <p className="login__status login__status_error">{codeStatus}</p> // Показываем статус кода
            )}
            <button
              onClick={submitCode}
              type="submit"
              className="login__button"
              style={{ backgroundColor: $SiteColors.getState().backBtnSubmit }} // Устанавливаем цвет кнопки
              disabled={
                !showLoaderCode && confirmValue.length === 4 ? false : true // Блокировка кнопки при невалидном коде
              }
            >
              {showLoaderCode && <Preloader small />}  
              {!showLoaderCode && "Войти в ЛК"} 
            </button>
          </div>
        </>
      </div>
    </div>
  );
};